import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Zap, Loader2, ArrowLeft, Mail, CheckCircle2 } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";
import api from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");
    try {
      const r = await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setMessage(r.data?.message || "");
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Nem sikerült elküldeni. Próbáld újra később.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dark min-h-screen bg-anthracite-900 text-white flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <Link
          to="/belepes"
          data-testid="forgot-back-login"
          className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-8"
        >
          <ArrowLeft className="w-4 h-4" /> Vissza a belépéshez
        </Link>

        <div className="glass rounded-3xl p-8">
          <div className="flex items-center gap-2 mb-2">
            <Zap className="w-6 h-6 text-electric" strokeWidth={1.5} />
            <span className="font-heading text-xl font-semibold">
              <BrandMark />
            </span>
          </div>
          <h1 className="font-heading text-2xl font-light mt-4">Elfelejtett jelszó</h1>
          <p className="text-slate-400 text-sm mt-1">
            Add meg a regisztrációkor használt email címedet. Ha van jelszavas fiókod, küldünk egy visszaállító linket.
          </p>

          {sent ? (
            <div
              data-testid="forgot-success"
              className="mt-6 rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-4 text-sm text-emerald-100"
            >
              <div className="flex items-start gap-2">
                <CheckCircle2 className="w-5 h-5 shrink-0 text-emerald-400" />
                <p>{message}</p>
              </div>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4 mt-6">
              <div>
                <label className="text-xs tracking-[0.15em] uppercase text-slate-400 block mb-2">Email</label>
                <div className="relative">
                  <Mail className="w-4 h-4 text-slate-500 absolute left-3 top-1/2 -translate-y-1/2" />
                  <input
                    data-testid="forgot-email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck={false}
                    className="w-full bg-white/[0.03] border border-white/10 rounded-xl py-3 pl-10 pr-3 text-sm text-white focus:border-electric outline-none transition-colors"
                  />
                </div>
              </div>
              {error && (
                <p data-testid="forgot-error" className="text-sm text-red-400">
                  {error}
                </p>
              )}
              <button
                data-testid="forgot-submit"
                type="submit"
                disabled={loading}
                className="w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-full bg-electric hover:bg-electric-light disabled:opacity-50 text-white font-medium transition-all"
              >
                {loading && <Loader2 className="w-4 h-4 animate-spin" />}
                Visszaállító link küldése
              </button>
            </form>
          )}

          <p className="text-xs text-slate-500 mt-6 leading-relaxed">
            Google vagy Apple fiókkal regisztráltál? Ott a „Folytatás Google-lel / Apple-lel” gombbal lépj be — külön jelszó
            nem kell.
          </p>
        </div>
      </div>
    </div>
  );
}
